module.exports = __webpack_public_path__ + "static/media/Tree.28fbc6d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Tree.jpg
// module id = 29
// module chunks = 0